import Device from '../../../devices/device';

// Detectar PS4 una sola vez a nivel de módulo
const _isPS4 = Device.getDevice().getPlatform() === 'ps4';

/**
 * Obtener el estilo de background-image.
 * En PS4 devuelve un objeto vacío si imageReady es false (lazy-loading).
 * En otras plataformas siempre devuelve el estilo completo.
 */
export function getCoverStyle(cover, imageReady) {
    if (!cover || cover === '') return {};
    if (_isPS4 && !imageReady) return {};
    return { backgroundImage: `url(${cover})` };
}

/**
 * Indica si la plataforma es PS4 (para decidir si usar lazy-loading).
 */
export function isPS4Platform() {
    return _isPS4;
}

/**
 * Limpiar la referencia de imagen de un elemento DOM para liberar memoria en PS4.
 */
export function clearCoverRef(element) {
    if (_isPS4 && element) {
        element.style.backgroundImage = '';
    }
}



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/ps4ImageUtils.js